// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================== */
/*        SCSS VARS       */
/* ===================== */
/* ===================== */
/*      CSS VARIABLES     */
/* ===================== */
:root {
  /* Text */
  --base-text-color: #1D1D1D;
  --darker-text-color: #202020;
  --brighter-text-color: #696969;
  /* UI */
  --base-ui-color: #1351F1;
  --warning-ui-color: #F8A01E;
  --secondary-ui-color: #E8E4E4;
  /* Background */
  --base-bg-color: #F5F5F5;
  /* Grays */
  --color-gray: #B2B2B2;
  --color-gray-2: #9E9E9E;
  --color-gray-3: #D8D8D8;
  --color-dark-gray: #676767;
  /* Fonts */
  --main-font: Noto Sans;
  --secondary-font: Roboto;
  --third-font: Open Sans;
  --fourth-font: Dosis;
  /* Error */
  --error-color: #E00000;
  /* Border */
  --border-color: #D8D8D8;
}

.fk-screen-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.fk-screen-header.--separator {
  padding: 0 0 20px 0;
  border-bottom: 1px solid #696969;
}
.fk-screen-header.--with-down-section {
  padding: 0 0 5px 0;
}
.fk-screen-header .top-section {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.fk-screen-header .top-section .title-container {
  display: flex;
  align-items: flex-start;
}
.fk-screen-header .top-section .title-container .title {
  display: flex;
  align-items: center;
  margin: 0;
  font: normal normal normal 20px/36px "Dosis";
  color: #434343;
}
.fk-screen-header .top-section .title-container .fk-input {
  min-width: 250px;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
}
.fk-screen-header .top-section .title-container .fk-input input {
  padding: 12px 0 12px 20px;
  font: normal normal normal 14px/14px "Dosis";
}
.fk-screen-header .top-section .title-container .fk-input input::placeholder {
  color: #9E9E9E;
}
.fk-screen-header .top-section .title-container .fk-input fieldset {
  border-color: #B2B2B2;
}
.fk-screen-header .top-section .title-container .fk-back-button {
  margin: 12px 10px 0 0;
  padding: 0;
}
.fk-screen-header .top-section .title-container .fk-back-button:hover {
  background-color: transparent;
  opacity: 0.5;
}
.fk-screen-header .screen-header-buttons {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 10px;
}
.fk-screen-header .screen-header-buttons.--flex-end {
  align-self: flex-end;
  justify-content: flex-end;
}
.fk-screen-header .screen-header-buttons .right-side {
  display: flex;
}
.fk-screen-header .screen-header-buttons .button-with-label {
  display: flex;
  align-items: center;
}
.fk-screen-header .screen-header-buttons .button-with-label label {
  font: normal normal bold 16px/20px Noto Sans;
}
.fk-screen-header .screen-header-buttons button {
  text-transform: none;
  font: normal normal bold 16px/22px Noto Sans;
  cursor: points;
}
.fk-screen-header .screen-header-buttons button.green {
  color: #1351F1;
}
.fk-screen-header .screen-header-buttons button.red {
  color: #E00000;
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/components/screenHeader/screenHeader.style.scss"],"names":[],"mappings":"AAAA,0BAAA;AACA,2BAAA;AACA,0BAAA;AA2BA,0BAAA;AACA,2BAAA;AACA,0BAAA;AAEA;EACE,SAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EAEA,OAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EAEA,eAAA;EACA,wBAAA;EAEA,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,uBAAA;EACA,0BAAA;EAEA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,uBAAA;EACA,oBAAA;EAEA,UAAA;EACA,sBAAA;EAEA,WAAA;EACA,uBAAA;AChCF;;AA7BA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;AAgCJ;AA9BI;EACI,mBAAA;EACA,gCAAA;AAgCR;AA7BI;EACI,kBAAA;AA+BR;AA5BI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;AA8BR;AA5BQ;EACI,aAAA;EACA,uBAAA;AA8BZ;AA5BY;EACI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,4CAAA;EACA,cAAA;AA8BhB;AA3BY;EACI,gBAAA;EACA,oDAAA;AA6BhB;AA3BgB;EACI,yBAAA;EACA,4CAAA;AA6BpB;AA3BoB;EACI,cAAA;AA6BxB;AAzBgB;EACI,qBAAA;AA2BpB;AAvBY;EACI,qBAAA;EACA,UAAA;AAyBhB;AAxBgB;EACI,6BAAA;EACA,YAAA;AA0BpB;AApBI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AAsBR;AApBQ;EACI,oBAAA;EACA,yBAAA;AAsBZ;AAnBQ;EACI,aAAA;AAqBZ;AAlBQ;EACI,aAAA;EACA,mBAAA;AAoBZ;AAlBY;EACI,4CAAA;AAoBhB;AAhBQ;EACI,oBAAA;EACA,4CAAA;EACA,cAAA;AAkBZ;AAhBY;EACI,cDpFA;ACsGhB;AAfY;EACI,cAAA;AAiBhB","sourcesContent":["/* ===================== */\n/*        SCSS VARS       */\n/* ===================== */\n\n$base-text-color: #1D1D1D;\n$darker-text-color: #202020;\n$brighter-text-color: #696969;\n\n$base-ui-color: #1351F1;\n$warning-ui-color: #F8A01E;\n$secondary-ui-color: #E8E4E4;\n\n$base-bg-color: #F5F5F5;\n\n$color-gray: #B2B2B2;\n$color-gray-2: #9E9E9E;\n$color-gray-3: #D8D8D8;\n$color-dark-gray: #676767;\n\n$main-font: \"Noto Sans\";\n$secondary-font: \"Roboto\";\n$third-font: \"Open Sans\";\n$fourth-font: \"Dosis\";\n\n$error-color: #E00000; // #ff1744\n\n$border-color: #D8D8D8;\n\n\n/* ===================== */\n/*      CSS VARIABLES     */\n/* ===================== */\n\n:root {\n  /* Text */\n  --base-text-color: #{$base-text-color};\n  --darker-text-color: #{$darker-text-color};\n  --brighter-text-color: #{$brighter-text-color};\n\n  /* UI */\n  --base-ui-color: #{$base-ui-color};\n  --warning-ui-color: #{$warning-ui-color};\n  --secondary-ui-color: #{$secondary-ui-color};\n\n  /* Background */\n  --base-bg-color: #{$base-bg-color};\n\n  /* Grays */\n  --color-gray: #{$color-gray};\n  --color-gray-2: #{$color-gray-2};\n  --color-gray-3: #{$color-gray-3};\n  --color-dark-gray: #{$color-dark-gray};\n\n  /* Fonts */\n  --main-font: #{$main-font};\n  --secondary-font: #{$secondary-font};\n  --third-font: #{$third-font};\n  --fourth-font: #{$fourth-font};\n\n  /* Error */\n  --error-color: #{$error-color};\n\n  /* Border */\n  --border-color: #{$border-color};\n}","@import '../../styles/variables';\n\n.fk-screen-header {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n\n    &.--separator {\n        padding: 0 0 20px 0;\n        border-bottom: 1px solid #696969;\n    }\n\n    &.--with-down-section {\n        padding: 0 0 5px 0;\n    }\n\n    .top-section {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n\n        .title-container {\n            display: flex;\n            align-items: flex-start;\n\n            .title {\n                display: flex;\n                align-items: center;\n                margin: 0;\n                font: normal normal normal 20px/36px $fourth-font;\n                color: #434343;\n            }\n\n            .fk-input {\n                min-width: 250px;\n                box-shadow: 0px 3px 10px #0000000D;\n\n                input {\n                    padding: 12px 0 12px 20px;\n                    font: normal normal normal 14px/14px $fourth-font;\n\n                    &::placeholder {\n                        color: #9E9E9E;\n                    }\n                }\n\n                fieldset {\n                    border-color: #B2B2B2;\n                }\n            }\n\n            .fk-back-button {\n                margin: 12px 10px 0 0;\n                padding: 0;\n                &:hover {\n                    background-color: transparent;\n                    opacity: .5;\n                }\n            }\n        }\n    }\n\n    .screen-header-buttons {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        margin-top: 10px;\n\n        &.--flex-end {\n            align-self: flex-end;\n            justify-content: flex-end;\n        }\n\n        .right-side {\n            display: flex;\n        }\n\n        .button-with-label {\n            display: flex;\n            align-items: center;\n\n            label {\n                font: normal normal bold 16px/20px Noto Sans;\n            }\n        }\n\n        button {\n            text-transform: none;\n            font: normal normal bold 16px/22px Noto Sans;\n            cursor: points;\n\n            &.green {\n                color: $base-ui-color;\n            }\n\n            &.red {\n                color: #E00000;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
